import { API } from './API.js'
import { BehaviorSubject } from 'rxjs'
import { clearMfaDeviceToken, getMfaDeviceToken, setMfaDeviceToken } from '../helpers/mfaDeviceCookie.js'
import { core } from '@config/core'

const token = new BehaviorSubject(JSON.parse(window.localStorage.getItem('token')))

export const authenticationService = {
  login,
  verifyMfa,
  loginWithToken,
  logout,
  refresh,
  register,
  clearMfaDeviceToken,
  currentToken: token.asObservable(),
  get currentTokenValue() {
    return token.value
  }
}

function storeToken(res) {
  window.localStorage.setItem('token', JSON.stringify(res))
  token.next(res)
  return res
}

function login(email, password) {
  const device_token = getMfaDeviceToken()
  return API.post(core.login, { email, password, device_token }).then(res => {
    if (res.mfa_required) {
      return res
    }
    return storeToken(res)
  })
}

function verifyMfa({ mfa_token, code, remember_device }) {
  return API.post(core.mfaVerify, { mfa_token, code, remember_device }).then(res => {
    if (res.device_token) {
      setMfaDeviceToken(res.device_token)
    }
    const authToken = { ...res }
    delete authToken.device_token
    return storeToken(authToken)
  })
}

function loginWithToken(tokenData) {
  window.localStorage.setItem('token', JSON.stringify(tokenData))
  token.next(tokenData)
  return tokenData
}
function register(data) {
  return API.post(core.register, data).then(res => {
    return res
  })
}
function refresh() {
  return API.post(core.refresh).then(res => {
    window.localStorage.setItem('token', JSON.stringify(res))
    token.next(res)
    return res
  })
}

//TODO
//support for refresh token request

function logout() {
  window.localStorage.removeItem('token')
  token.next(null)
}
